


































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { ReminderModel, RemindersClient } from "@/diamond-support-api";
import { ErrorMessage, SuccessMessage, SystemMessage } from "@/shared";
import moment from "moment";

@Component
export default class ReminderAdd extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;

  shown = true;
  loading = false;
  search = "";

  dueOnDate = "";
  dueOnTime = "";
  dueOnTimeMenu = false;
  dueOnDateMenu = false;

  defaultDate = null;
  defaultTime = null;

  reminder: ReminderModel = new ReminderModel();
  remindersApi = new RemindersClient();
  rules = {
    required: [(value: any) => !!value || "Required."],
  };

  mounted() {
    var defaultDateTime = new Date(new Date().valueOf() + 1000 * 3600 * 24);
    this.dueOnDate = moment(defaultDateTime).format("YYYY-MM-DD");
    this.dueOnTime = moment(defaultDateTime).format("HH:mm");
  }

  async save() {
    if (this.$route.params.id) {
      this.reminder.distributorId = this.$route.params.id;
      this.reminder.dueOnUtc = moment
        .utc(new Date(`${this.dueOnDate} ${this.dueOnTime}`))
        .toDate();
      if (this.reminder.dueOnUtc < new Date()) {
        this.showMessage(
          new ErrorMessage(`Due On Time must be the futrue time`)
        );
      } else if (!this.dueOnTime) {
        this.showMessage(new ErrorMessage(`Due On Time must be selected `));
      } else {
        this.loading = true;
      await this.remindersApi
        .post(this.reminder)
        .then((response) => {
          if (response !== null)
            this.showMessage(new SuccessMessage(`New reminder has been saved.`));
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    }
    this.shown = false;
  }

  @Watch("dueOnDate")
  onDueOnDateChanged(val: string | null, oldVal: string | null) {
    if (val && !oldVal) return;
    if (val != oldVal) this.dueOnTime = "";
  }

  @Watch("shown")
  onShownChanged() {
    if (!this.shown)
      this.$router.push(`/associates/${this.$route.params.id}/detail`);
  }
}
